// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.toggle-subject-comment-btn-student {
  background-color: transparent;
  color: #0A4064;
  border: none;
  padding: 0px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
}
.toggle-subject-comment-btn-student i {
  margin-right: 6px;
}
.toggle-subject-comment-btn-student:hover {
  color: #1786DB;
}

.subject-comment-textarea {
  border: 1px solid #A7A9AC;
  border-radius: 5px;
  font-size: 14px;
  margin-top: 16px;
  min-height: 60px;
  padding: 5px;
  resize: vertical;
  width: 100%;
}

.subject-main-section {
  background: #676666;
  border-radius: 10px;
  padding: 12px 16px;
}

/* Hub around subject selection */
.subject-hub {
  border-radius: 12px;
  padding: 10px 0px 12px;
}
.subject-hub__header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
}
.subject-hub__label {
  font-size: 20px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.subject-hub__name {
  font-size: 24px;
  font-weight: 700;
  color: #24334a;
}
.subject-hub__tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Generic section card (used for Comments and Ratings) */
.section-card {
  background: #fff;
  border: 1px solid #e3e6ea;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin: 10px 0 16px;
}
.section-card__header {
  padding: 10px 14px;
  border-bottom: 1px solid #e9edf2;
  background: #f8f9fb;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.section-card__title {
  margin: 0;
  font-weight: 600;
  color: #444343;
}
.section-card__body {
  padding: 12px 14px;
}

/* Stack of comment cards inside the Comments section */
.comments-stack {
  display: grid;
  gap: 12px;
}

/* Individual comment card */
.comment-card {
  border: 1px solid #e8ecf2;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
}
.comment-card__title {
  font-weight: 700;
  color: #444343;
  margin-bottom: 12px;
}

.comment-textarea {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #cfd7e3;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.4;
  resize: vertical;
  transition: box-shadow 120ms ease, border-color 120ms ease;
}
.comment-textarea:focus {
  outline: none;
  border-color: #4c9aff;
  box-shadow: 0 0 0 0.2rem rgba(76, 154, 255, 0.18);
}

.comment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.permissions-info {
  background-color: white;
  border: 2px solid #FEBF31;
  border-radius: 5px;
  margin: 12px 0px;
  padding: 12px;
}

.view-only-badge {
  background-color: #FEBF31;
  border: 1px solid #444343;
  border-radius: 5px;
  font-weight: 500;
  margin: 4px 0px;
  padding: 4px 16px;
  width: fit-content;
}

.student-switcher__row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.student-switcher__btn {
  border: none;
  background: none;
  border-radius: 6px;
  color: #0A4064;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.student-switcher__btn i {
  font-size: 18px;
  line-height: 1;
}
.student-switcher__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.student-switcher__select {
  color: #0A4064;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 4px 10px;
  background: #fff;
  font-size: 20px;
  font-weight: 600;
}

.fluency-wpm-field {
  border: 1px solid #D1D3D4;
  border-left: 4px solid #0669B3;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 12px 16px;
}
.fluency-wpm-field__label {
  font-size: 16px;
  font-weight: 700;
}
.fluency-wpm-field__stem {
  color: #444343;
  font-size: 14px;
  margin: 8px 0 12px;
}
.fluency-wpm-field__guidance-block {
  background: #EDF0F1;
  border: 1px solid #D1D3D4;
  border-radius: 6px;
  margin: 0 0 12px;
  padding: 8px 12px;
}
.fluency-wpm-field__guidance-label {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.fluency-wpm-field__guidance {
  color: #444343;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
}
.fluency-wpm-field__input-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
}
.fluency-wpm-field__input {
  width: 88px;
  padding: 6px 8px;
  border: 1px solid #808080;
  border-radius: 4px;
  font-weight: 400;
}
.fluency-wpm-field__result {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #D1D3D4;
  padding-top: 10px;
}
.fluency-wpm-field__result-label {
  font-size: 13px;
  font-weight: 600;
}
.fluency-wpm-field__result-value {
  font-size: 15px;
  font-weight: 700;
  color: #0A4064;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SingleStudentRatings.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,6BAAA;EACA,cDIQ;ECHR,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAUF;AARE;EACE,iBAAA;AAUJ;AAPE;EACE,cDgBe;ACPnB;;AALA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAQF;;AALA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;AAQF;;AALA,iCAAA;AACA;EACE,mBAAA;EACA,sBAAA;AAQF;AANE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;AAQJ;AALE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;AAOJ;AAJE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAMJ;AAHE;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAKJ;;AADA,yDAAA;AACA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mBAAA;AAIF;AAFE;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAIJ;AADE;EACE,SAAA;EACA,gBAAA;EACA,cD9DK;ACiET;AAAE;EACE,kBAAA;AAEJ;;AAEA,uDAAA;AACA;EACE,aAAA;EACA,SAAA;AACF;;AAEA,4BAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,cDrFK;ECsFL,mBAAA;AACJ;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0DAAA;AAAF;AAEE;EACE,aAAA;EACA,qBAAA;EACA,iDAAA;AAAJ;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AADF;;AAIA;EACE,yBDpIU;ECqIV,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFJ;AAKE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,cDtKM;ECuKN,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAHJ;AAKI;EACE,eAAA;EACA,cAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;AAJN;AAQE;EACE,cD1LM;EC2LN,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AANJ;;AAeA;EACE,yBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;AAZJ;AAeE;EACE,cD/LK;ECgML,eAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,mBD3MI;EC4MJ,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AAfJ;AAkBE;EACE,cDrNK;ECsNL,eAAA;EACA,gBAAA;EACA,SAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,cDnRM;AC8PV","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.toggle-subject-comment-btn-student {\n  background-color: transparent;\n  color: $dk-blue;\n  border: none;\n  padding: 0px;\n  border-radius: 3px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n\n  i {\n    margin-right: 6px;\n  }\n\n  &:hover {\n    color: $pearl-blue-hover;\n  }\n}\n\n.subject-comment-textarea {\n  border: 1px solid $grey2;\n  border-radius: 5px;\n  font-size: 14px;\n  margin-top: 16px;\n  min-height: 60px;\n  padding: 5px;\n  resize: vertical;\n  width: 100%;\n}\n\n.subject-main-section {\n  background: #676666;\n  border-radius: 10px;\n  padding: 12px 16px;\n}\n\n/* Hub around subject selection */\n.subject-hub {\n  border-radius: 12px;\n  padding: 10px 0px 12px;\n\n  &__header {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  &__label {\n    font-size: 20px;\n    font-weight: 600;\n    color: white;\n    text-transform: uppercase;\n    letter-spacing: .04em;\n  }\n\n  &__name {\n    font-size: 24px;\n    font-weight: 700;\n    color: #24334a;\n  }\n\n  &__tabs {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n}\n\n/* Generic section card (used for Comments and Ratings) */\n.section-card {\n  background: #fff;\n  border: 1px solid #e3e6ea;\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  margin: 10px 0 16px;\n\n  &__header {\n    padding: 10px 14px;\n    border-bottom: 1px solid #e9edf2;\n    background: #f8f9fb;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__title {\n    margin: 0;\n    font-weight: 600;\n    color: $grey4a;\n  }\n\n  &__body {\n    padding: 12px 14px;\n  }\n}\n\n/* Stack of comment cards inside the Comments section */\n.comments-stack {\n  display: grid;\n  gap: 12px;\n}\n\n/* Individual comment card */\n.comment-card {\n  border: 1px solid #e8ecf2;\n  border-radius: 10px;\n  padding: 12px;\n  background: #fff;\n\n  &__title {\n    font-weight: 700;\n    color: $grey4a;\n    margin-bottom: 12px;\n  }\n}\n\n.comment-textarea {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #cfd7e3;\n  padding: 10px 12px;\n  font-size: 14px;\n  line-height: 1.4;\n  resize: vertical;\n  transition: box-shadow 120ms ease, border-color 120ms ease;\n\n  &:focus {\n    outline: none;\n    border-color: #4c9aff;\n    box-shadow: 0 0 0 0.2rem rgba(76, 154, 255, 0.18);\n  }\n}\n\n.comment-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.permissions-info {\n  background-color: white;\n  border: 2px solid $important;\n  border-radius: 5px;\n  margin: 12px 0px;\n  padding: 12px;\n}\n\n.view-only-badge {\n  background-color: $important;\n  border: 1px solid $grey4a;\n  border-radius: 5px;\n  font-weight: 500;\n  margin: 4px 0px;\n  padding: 4px 16px;\n  width: fit-content;\n}\n\n.student-switcher {\n  &__row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__btn {\n    border: none;\n    background: none;\n    border-radius: 6px;\n    color: $dk-blue;\n    width: 34px;\n    height: 34px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    i {\n      font-size: 18px;\n      line-height: 1;\n    }\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n  }\n\n  &__select {\n    color: $dk-blue;\n    border-radius: 6px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    padding: 4px 10px;\n    background: #fff;\n    font-size: 20px;\n    font-weight: 600;\n  }\n}\n\n$rating-blue: #1179ef;\n$rating-green: #C7CC68;\n$rating-orange: $important;\n$rating-red: #e27319;\n\n.fluency-wpm-field {\n  border: 1px solid $grey1;\n  border-left: 4px solid $pearl-blue;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n\n  &__label {\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  &__stem {\n    color: $grey4a;\n    font-size: 14px;\n    margin: 8px 0 12px;\n  }\n\n  &__guidance-block {\n    background: $grey0;\n    border: 1px solid $grey1;\n    border-radius: 6px;\n    margin: 0 0 12px;\n    padding: 8px 12px;\n  }\n\n  &__guidance-label {\n    font-size: 12px;\n    font-weight: 700;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n  }\n\n  &__guidance {\n    color: $grey4a;\n    font-size: 13px;\n    line-height: 1.4;\n    margin: 0;\n  }\n\n  &__input-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  &__input {\n    width: 88px;\n    padding: 6px 8px;\n    border: 1px solid $grey3;\n    border-radius: 4px;\n    font-weight: 400;\n  }\n\n  &__result {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    border-top: 1px solid $grey1;\n    padding-top: 10px;\n  }\n\n  &__result-label {\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  &__result-value {\n    font-size: 15px;\n    font-weight: 700;\n    color: $dk-blue;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
